export default "__VITE_ASSET__78c93fc4__"